import api from "@/services/api";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

interface GeneratePresignedUrlParams {
  fileName: string;
  mimeType: string;
  type: "IMAGE" | "DOCUMENT";
  size: number;
}

interface PresignedUrlResponse {
  uploadUrl: string;
  key: string;
  bucket: string;
}

export const useGeneratePresignedUrl = () => {
  return useMutation({
    mutationKey: ["generatePresignedUrl"],
    mutationFn: async (params: GeneratePresignedUrlParams) => {
      const response = await api.post<PresignedUrlResponse>(
        "/storage/presigned-url",
        params
      );
      return response.data;
    },
  });
};

export const uploadFileToR2 = async (uploadUrl: string, file: File) => {
  await axios.put(uploadUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
  });
};
